import {Injectable} from '@angular/core';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { environment } from '@env';
import {BehaviorSubject, Observable} from 'rxjs';
import {LDContext, LDFlagValue} from 'launchdarkly-js-client-sdk';
import {map} from 'rxjs/operators';

export enum FlagKeys {
    HIDE_BUTTONS = 'hide-emm-buttons',
    PIN_OVERRIDES_PUBLISHING = 'pin-overrides-publishing',
    DISABLE_LOCATION_SETS = 'disable-location-sets',
    REMOVE_CHILD_ITEM_FROM_GROUPING = 'remove-child-item',
    SHOW_HIERARCHY_TABLE = 'show-hierarchy-tanle',
    ENABLE_THIRD_PARTY_PRICING = 'enable-third-party-pricing',
    APPLY_LEAST_PRECEDENCE_FOR_ITEM_LOCKS = 'least-precedence-for-item-locks',
    APPLY_FORCE_OVERRIDE_PER_ATTRIBUTE = 'apply-force-override-per-attribute',
    USE_FIELD_RULES = 'use-field-rules',
    USE_COMMON_ITEMS = 'use-common-items-poc',
    REMOVE_MEAL_FORMFIELD = 'remove-meal-formfield',
    REMOVE_LOCATIONS_IN_GMB ='remove-locations-in-gmb',
}

@Injectable({
    providedIn: 'root',
})
export class LaunchDarklyService {

    client: LDClient.LDClient;
    options: LDClient.LDOptions;
    private context$ = new BehaviorSubject<LDContext>({kind: 'user', key: 'EMM User'});

    constructor() {
        this.options = {streaming: true};
        this.client = LDClient.initialize(environment.LDClientId, this.context$.getValue(), this.options);
    }

    switchContext(context: LDContext) {
        if (JSON.stringify(this.context$.getValue()) !== JSON.stringify(context)) {
            this.client.identify(context).then(() => {
                    this.context$.next(context)
            });
        }
    }

    getFlag(flagKey: string, defaultValue: LDFlagValue = false): Observable<LDFlagValue> {
        const fetchFlag = new BehaviorSubject<LDFlagValue>(defaultValue);
        this.client.on(`ready`, () => {
            const variation = this.client.variation(flagKey, false);
            console.log(`Flag value for ${flagKey} ready: ${variation}`);
            fetchFlag.next(variation);
        });
        this.client.on(`change:${flagKey}`, () => {
            const variation = this.client.variation(flagKey, defaultValue);
            console.log(`Flag value for ${flagKey} changed: ${variation}`);
            fetchFlag.next(variation);
        });
        this.context$.subscribe(() => {
            const variation = this.client.variation(flagKey, defaultValue);
            console.log(`Flag value for ${flagKey} changed: ${variation}`);
            fetchFlag.next(variation);
        });
        return fetchFlag;
    }

    getBooleanFlag(flagKey: string, defaultValue: LDFlagValue = false): Observable<boolean> {
        return this.getFlag(flagKey, defaultValue).pipe(
            map((value) => {
                return !!value;
            })
        )
    }

    // Prefer not to use this one, as it does not update.
    getBooleanFlagValue(flagKey: string, defaultValue: LDFlagValue = false): boolean {
        let value: boolean;
        this.getBooleanFlag(flagKey, defaultValue).pipe().subscribe(v => {
            console.log('setting', v);
            value = v;
        });
        return value;
    }
}
